import { useCustomMutation } from '../../hooks/useCustomMutation';
import * as ENDPOINTS from './endpoints';

export const QUERY_KEYS = {
  teamListHeatmap: 'teamListHeatmap',
  teamComparisonTeams: 'teamComparisonTeams',
};

export const useSaveTeamComparisonTeamsMutation = () => {
  return useCustomMutation(
    [QUERY_KEYS.teamComparisonTeams],
    ENDPOINTS.postTeamComparisonTeams
  );
};
